(function () {
  function disableOverflow() {
    const overflowList = document.querySelector("overflow-list");
    if (!overflowList) return;

    overflowList.style.setProperty("--overflow-count", "0");
    overflowList
      .querySelectorAll('[slot="overflow"]')
      .forEach((el) => el.removeAttribute("slot"));
    overflowList
      .querySelectorAll('[slot="more"]')
      .forEach((el) => (el.style.display = "none"));
  }

  // Run once on load, no MutationObserver
  window.addEventListener("load", disableOverflow);

  // And once half a second later in case the component initialises late
  window.addEventListener("load", () => setTimeout(disableOverflow, 500));
})();
